module.exports = __webpack_public_path__ + "static/media/logo_mpv.e91b8543.png";